import React from "react";

import { RouteComponentProps, Router } from "@reach/router";

import NotFound from "pages/not-found";
import ApplicantDetails from "./details";
import ApplicantsIndex from "./list";
import ApplicantsNew from "./new";

const Applicants: React.FC<RouteComponentProps> = () => (
  <Router primary={false}>
    <ApplicantsIndex path="/" />
    <ApplicantsNew path="/new" />
    <ApplicantDetails path="/:id" />

    <NotFound default />
  </Router>
);

export default Applicants;
